import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

const useStyles = makeStyles()(() => ({
  row: {
    ...dFlex(),
    gap: '16px',
    marginTop: '16px',
  },
  wrap: {
    ...dFlex('space-between', 'unset'),
    flexDirection: 'column',
    height: '100%',
  },
}));

export default useStyles;
